import { useQuery } from '@tanstack/react-query'
import {
  BoosterProgramEnrolledUser,
  SearchBoosterEnrolledUsersParams,
} from 'Modules'

import { AppAdmin } from 'api/app-admin'
import { mapApiToEnrolledUser } from 'modules/booster-program/api-adapters'
import { logError } from 'utils/logger'

import { boosterProgramKeys } from './query-keys'

interface EnrolledResult {
  results: BoosterProgramEnrolledUser[]
  total: number
}

const fetchEnrolled = async (
  programId: string,
  params: SearchBoosterEnrolledUsersParams
): Promise<EnrolledResult> => {
  try {
    const res = await AppAdmin.getBoosterProgramEnrolledUsers(programId, params)
    if (!res.data?.success || !res.data.data) return { results: [], total: 0 }
    const payload = res.data.data
    return {
      results: (payload.results ?? []).map(mapApiToEnrolledUser),
      total: payload.totalUsers ?? 0,
    }
  } catch (error) {
    logError('Error fetching booster enrolled users:', error)
    return { results: [], total: 0 }
  }
}

export const useBoosterEnrolledUsers = (
  programId: string | undefined,
  params: SearchBoosterEnrolledUsersParams
) => {
  const query = useQuery({
    queryKey: boosterProgramKeys.enrolled(programId, params),
    queryFn: () => fetchEnrolled(programId!, params),
    enabled: !!programId,
  })

  return {
    enrolled: query.data?.results ?? [],
    total: query.data?.total ?? 0,
    isLoading: query.isLoading,
  }
}
